import { useState } from 'react'
import { FiEye, FiEyeOff } from 'react-icons/fi'
import './input.css'

function Input({ text, type, name, placeholder, handleOnChange, value, disabled }) {
    const [inputType, setInputType] = useState(type || 'text')

    return (
        <div className="input-group">
            {text && <label htmlFor={name}>{text}</label>}
            <div className="input-box">
                <input
                    className="input"
                    type={type === 'password' ? inputType : type}
                    name={name}
                    id={name}
                    placeholder={placeholder}
                    onChange={handleOnChange}
                    value={value}
                    disabled={disabled}
                />
                {type === 'password' && (
                    <div className="input-eye" onClick={() => setInputType(inputType === 'password' ? 'text' : 'password')}>
                        {inputType === 'password' ? <FiEye size={17} /> : <FiEyeOff size={17} />}
                    </div>
                )}
            </div>
        </div>
    )
}

export default Input
